import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { News } from '../../model/news.model';
import { ApiService } from '../../services/api.service';
import { Tabs } from './tabs';

@Component({
  selector: 'ngx-other-news-list',
  templateUrl: './other-news-list.component.html',
  styleUrls: ['./other-news-list.component.scss']
})
export class OtherNewsListComponent implements OnInit {
  tabs = Tabs;
  public news: News[];
  
  public date: any;
  constructor(private router : Router,
              private _apiService: ApiService) { }

  ngOnInit(): void {
    this.getNews(this.router.url);
    
  }
  getNews(url){
    // Cutting the url to get the name of category - api category has same name as the urls last part 
    let newsPage = url.substring(url.lastIndexOf('/') + 1);
    // Filter page and get ONLY the posts that belong to the category thats been sliced from url
    this._apiService.getNews("?filters[categories][name][$eq]="+newsPage).subscribe((res) => {
      this.news = res['data'];
    });
  }
 
}
